export default __webpack_public_path__ + "static/siu2-90764f15799bfa444c1ec2d0a6760649.png";